import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ExpandableContent extends UcoastEl {
	static htmlSelector = 'expandable-content'
	mainDetailsToggle: HTMLDetailsElement
	summary: HTMLElement
	content: HTMLElement
	expandGroupSelector?: string
	expandItemSelector?: string

	constructor() {
		super()
		this.mainDetailsToggle = q.rs('details', this)
		this.summary = q.rs('summary', this.mainDetailsToggle)
		this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
		this.summary.addEventListener('click', this.onClick.bind(this))
		this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
		this.content = q.rs('[data-expandable-area]', this)
		this.mainDetailsToggle.addEventListener('keyup', q.onKeyUpEscape)
		this.expandGroupSelector = q.oa(this, 'data-external-group')
		this.expandItemSelector = q.oa(this, 'data-external-item')
	}

	override animateIn() {
		super.animateIn()
		const expandSelector = this.expandItemSelector
		void window.Ucoast.mediaManager.playAllInContainer(this)
		if (!expandSelector) return
		q.ol(`[data-expandable-item="${expandSelector}"]`)?.forEach((item) => {
			void window.Ucoast.mediaManager.playAllInContainer(item)
		})

	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
		q.rs('summary', this.mainDetailsToggle).setAttribute('aria-expanded', 'false')
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.animateClose()
		})
	}

	onToggle(e: Event) {
		e.preventDefault()
	}

	onClick(e: Event) {
		e.preventDefault()
		this.content.getAnimations().forEach(animation => animation.cancel())
		if (this.summary.getAttribute('aria-expanded') !== 'true') {
			this.animateOpen()
		} else {
			this.animateClose()
		}
	}

	animateOpen() {
		this.mainDetailsToggle.setAttribute('open', '')
		this.summary.setAttribute('aria-expanded', 'true')
		this.content.style.maxHeight = `${this.content.scrollHeight}px`
		this.activateExpandableItem()
		this.closeGroupItems()
	}

	activateExpandableItem() {
		if (!this.expandGroupSelector || !this.expandItemSelector) {
			return
		}
		q.rl(`[data-expandable-group="${this.expandGroupSelector}"]`).forEach((item) => {
			if (item.getAttribute('data-expandable-item') === this.expandItemSelector) {
				item.classList.add('active')
			} else {
				item.classList.remove('active')
			}
		})
	}

	closeGroupItems() {
		if (!this.expandGroupSelector) return
		q.rl<ExpandableContent>(`[data-external-group="${this.expandGroupSelector}"]`).forEach((item) => {
			if (item !== this) {
				item.animateClose()
			}
		})
	}

	isOnlyOpenItemInGroup() {
		if (!this.expandGroupSelector) return false
		return Array.from(q.rl<ExpandableContent>(`[data-external-group="${this.expandGroupSelector}"]`)).filter((item) => {
			return item.mainDetailsToggle.hasAttribute('open')
		}).length < 2
	}

	animateClose() {
		if (this.isOnlyOpenItemInGroup()) return
		this.content.style.maxHeight = `0`
		this.summary.setAttribute('aria-expanded', 'false')
		window.setTimeout(() => {
			this.mainDetailsToggle.removeAttribute('open')
		}, 201)
	}
}
